import { useIntl } from '@capsicum/common';
import { type RecoveryErrorKind } from '@socios-blk/browser';
import { useState } from 'react';
import { z } from 'zod';

const useFormSchema = () => {
	const { $t } = useIntl();

	return z.object({
		recoveryCode: z
			.string()
			.nonempty(
				$t('requirements.common.form.errors.required', {
					field: $t('ncOnboarding.recoveryKit.form.inputRecoveryCode')
				})
			)
			.regex(
				/^[A-Z0-9]{2}-[A-Z0-9]{6}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{6}$/,
				$t('ncOnboarding.recoveryKit.form.inputRecoveryCodeFormatError')
			)
			.max(41),
		recoveryKitId: z
			.string()
			.nonempty(
				$t('requirements.common.form.errors.required', {
					field: $t('ncOnboarding.recoveryKit.form.inputRecoveryKeyId')
				})
			)
			.regex(/^[a-zA-Z0-9\-_]*$/, $t('ncOnboarding.recoveryKit.form.inputRecoveryCodeFormatError'))
			.max(48)
	});
};

const useIntlTexts = () => {
	const { $t } = useIntl();

	return {
		explanation: $t('ncOnboarding.recoveryKit.recoverWallet.explanation'),
		info: $t('ncOnboarding.recoveryKit.recoverWallet.infoBox'),
		inputRecoveryCode: $t('ncOnboarding.recoveryKit.form.inputRecoveryCode'),
		inputRecoveryKeyId: $t('ncOnboarding.recoveryKit.form.inputRecoveryKeyId'),
		submitForm: $t('global.button.submit'),
		title: $t('ncOnboarding.recoveryKit.recoverWallet.title')
	};
};

export const useNCWalletRecovery = () => {
	const [error, setError] = useState<RecoveryErrorKind | undefined>();

	return {
		error,
		formSchema: useFormSchema(),
		intlTexts: useIntlTexts(),
		setError
	};
};
